import React, { FunctionComponent } from 'react';

import { StyledContainer } from './container.styled';

export type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

export const Container: FunctionComponent<ContainerProps> = (props) => <StyledContainer {...props} />;
